import { Button } from "components/common/buttons/Button";
import { CUSTOMER_SUCCESS_EMAIL, CUSTOMER_SUCCESS_MAILTO } from "config/constant";
import { DeactivatedBannerProps } from "./DeactivatedBanner.types";

export const DeactivatedBanner = ({ className, onActivate }: DeactivatedBannerProps) => (
  <div className={`bg-danger/10 border border-danger/20 rounded-lg p-4 ${className}`}>
    <div className="text-danger text-sm font-medium mb-2">Account Deactivated</div>
    <div className="text-danger/80 text-xs mb-3">
      Your account has been deactivated. Please contact{" "}
      <a href={CUSTOMER_SUCCESS_MAILTO} className="underline hover:text-danger">
        {CUSTOMER_SUCCESS_EMAIL}
      </a>
      .
    </div>
    <Button size="sm" onClick={onActivate} className="w-full">
      Reactivate Account
    </Button>
  </div>
);
